import constate from 'constate';
import { useState } from 'react';

const useSelectionCount = () => {
  const [selectionCount, setSelectionCount] = useState(0);

  return { selectionCount, setSelectionCount };
};

export const [SelectionCountProvider, useSelectionCountContext] = constate(useSelectionCount);
